import consumer from "channels/consumer"

class CLECourseChannel {
  constructor(attendanceHandler, video, pauseVideoCallback) {
    this.handler = attendanceHandler
    this.video = video
    this.pauseVideoCallback = pauseVideoCallback.bind(attendanceHandler)
  }

  run() {
    const that = this

    this.subscription = consumer.subscriptions.create("CLE::CourseChannel", {
      received(data) {
        if (data.action === "pause_videos" && !data.except.includes(that.video.hashedId())) {
          that.pauseVideoCallback(data.title)
        }
      }
    })
  }

  sendVideoPlayEvent() {
    this.subscription.perform("play", { "id": this.video.hashedId(), "title": this.handler.config.videoName })
  }
}

export default CLECourseChannel
